import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

interface GridContainerProps {
	children: ReactNode
	className?: string
}

export default function Container({ children, className }: GridContainerProps) {
	const defaultClass =
		'w-full max-w-container mx-auto px-6 sm:px-6 md:px-8 xl:px-0'

	const combinedClasses = twMerge(defaultClass, className)

	return <div className={combinedClasses}>{children}</div>
}
